import React from 'react';

import Day from '@commons/CalendarDatePicker/Day';

import styles from './week.scss';

interface WeekProps {
  ariaLabelForSelected?: string;
  days?: unknown[];
  focusThisDay?: number;
  inverseLeftRightArrowMovement?: boolean;
  notInTheFuture?: boolean;
  onDayClick?: (...args: unknown[]) => unknown;
  onDayTabPress?: (...args: unknown[]) => unknown;
  onKeyPressFocusDay?: (...args: unknown[]) => unknown;
  selectedValue?: string;
  tabbableDay?: number;
  today?: {
    year?: number;
    month?: number;
    day?: number;
  };
}

export default function Week({
  ariaLabelForSelected,
  days = Array(7),
  focusThisDay,
  inverseLeftRightArrowMovement,
  notInTheFuture,
  onDayClick,
  onDayTabPress,
  onKeyPressFocusDay,
  selectedValue,
  tabbableDay,
  today
}: WeekProps) {
  const daysInOneWeek = [];
  for (let day = 0; day <= 6; day++) {
    const dayProps = days[day];
    const value = dayProps ? dayProps.value : null;
    daysInOneWeek.push(
      <Day
        key={day}
        {...dayProps}
        ariaLabelForSelected={ariaLabelForSelected}
        focusThisDay={focusThisDay}
        inverseLeftRightArrowMovement={inverseLeftRightArrowMovement}
        isSelected={selectedValue === value}
        notInTheFuture={notInTheFuture}
        onDayClick={onDayClick}
        onDayTabPress={onDayTabPress}
        onKeyPressFocusDay={onKeyPressFocusDay}
        tabbableDay={tabbableDay}
        today={today}
      />
    );
  }

  return <tr className={styles.week}>{daysInOneWeek}</tr>;
}
